import {
  canAdd,
  canRemove,
  extractOnlyElementNodes,
  getFirstHiddenElement,
  hideLastItem,
  showLastItem,
  sumWidthDomElements,
  moreArrowBtnIsExist,
  addMoreArrowBtn,
  hideMoreArrowBtn,
  moreArrowBtnIsVisible,
  showMoreArrowBtn
} from "./helpers";
import {
  MORE_ARROW_BTN_CLASS,
  NAV_BAR_CLASS,
  NAV_BAR_ELEMENTS,
  NAV_BAR_ITEMS_CLASS
} from "./constans";

export const MENU_IS_VISIBLE_UP = 991;

export const checkNav = (event) => {
  const navBar = document.querySelector(`.${NAV_BAR_CLASS}`);
  const navBarWidth = sumWidthDomElements(navBar, NAV_BAR_ELEMENTS);

  const navBarContainer = navBar.querySelector(`.${NAV_BAR_ITEMS_CLASS}`);
  const navBarItems = extractOnlyElementNodes(
    navBar.querySelector(`.${NAV_BAR_ITEMS_CLASS}`)
  );

  let result = false;

  if (canRemove(navBarWidth)) {
    hideLastItem(navBarItems);
    if(event.type === 'load') checkNav(event);
    result = true;
  } else if (canAdd(navBarWidth, navBarItems)) {
    showLastItem(navBarItems);
    if(event.type === 'load') checkNav(event);
    result = true;
  } else {
    if (
      getFirstHiddenElement(navBarItems) !== false &&
      !moreArrowBtnIsExist(navBarContainer)
    ) {
      addMoreArrowBtn(navBarContainer);
    }

    if (
      getFirstHiddenElement(navBarItems) !== false &&
      !moreArrowBtnIsVisible(navBarContainer)
    ) {
      showMoreArrowBtn(navBarContainer);
    }

    if (
      getFirstHiddenElement(navBarItems) === false &&
      moreArrowBtnIsExist(navBarContainer)
    ) {
      hideMoreArrowBtn(navBarContainer);
    }

    result = false;
  }

  return result;
};

window.addEventListener("resize", checkNav);
window.addEventListener("load", checkNav);
